class BundleDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'bundle-drawer--open',
      opening: 'bundle-drawer--opening',
      closing: 'bundle-drawer--closing'
    });

    // Cleanup
    this.addEventListener('close', () => {
      setTimeout(() => {
        this.remove();
      }, 400);
    });
  }

  connectedCallback() {
    // void this.querySelector('[data-drawer]').offsetHeight;

    const summary = this.querySelector('summary');
    summary.click();

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'product-form') {
        this.closeSubmenu(summary.closest('details'));
      }
    });
  }
}

if ('customElements' in window) {
  customElements.define('bundle-drawer', BundleDrawer);
}

class BundleDrawerTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.template = this.querySelector('template');

    if (!this.template) return;

    this.init();
  }

  init() {
    this.addEventListener('click', (event) => {
      event.stopPropagation();
      this.renderDrawer();
    });
  }

  renderDrawer() {
    const contents = this.template.content.cloneNode(true);
    const appendElement = document.querySelector(this.getAttribute('data-append-selector')) || document.body;

    appendElement.appendChild(contents);
  }
}

if ('customElements' in window) {
  customElements.define('bundle-drawer-trigger', BundleDrawerTrigger);
}


class BundleForm extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onSubmitHandler(evt) {
    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
      return;
    }

    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');

    if (submitButton.classList.contains('loading')) {
      return;
    }

    this.handleErrorMessage();

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    if (this.miniCart) {
      formData.append('sections', this.miniCart.getSectionsToRender().map((section) => section.id));
    }

    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${theme.routes.cart_add_url}.js`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          this.error = true;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
        this.error = false;

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

    if (this.errorMessageWrapper) {
      if (this.hideErrors) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}

if ('customElements' in window) {
  customElements.define('bundle-form', BundleForm);
}
